import React, { FC } from 'react'

import { areDatesInSameMonth, formatDate } from '../../../../../helpers/date/parser'
import { LoadingSpinner } from '../../../../components'
import { TimeModeType } from '../../../../types/timeModeTypes'
import Day from './Day'
import { DayBasis } from './models'

export interface DaysProps extends DayBasis {
    isLoading: boolean
    selectedDays: Date[]
}

const Days: FC<DaysProps> = ({
    isLoading,
    selectedDays,
    shifts,
    mode,
    showHeader,
}) => (
    <>
        {selectedDays.map((day, index) => {
            const key = formatDate(day, 'yyyy-MM-dd')
            const outOfRange = mode === TimeModeType.month && ! areDatesInSameMonth(day, selectedDays[selectedDays.length - 1])

            return (
                <Day
                    showDate
                    key={key}
                    shifts={shifts}
                    index={index}
                    showHeader={index < 7 && showHeader}
                    day={day}
                    mode={mode}
                    outOfRange={outOfRange}
                    last={selectedDays.length - 1 === index}
                />
            )
        })}
        {isLoading && <LoadingSpinner className="calendar-days__loading-spinner" />}
    </>
)

export default Days
